import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import { RadioDriver } from './../Radio/Radio.driver';

export interface RadioGroupDriver extends BaseDriver {
  selectByValue: (value: string | number) => void;
  selectByIndex: (index: number) => void;
  getRadioValueAt: (index: number) => string | number;
  getRadioIdAt: (index: number) => string;
  getRadioName: () => string;
  getRadioAtIndex: (index: number) => HTMLElement & RadioDriver;
  getSelectedValue: () => string | number | null;
  isRadioDisabled: (index: number) => boolean;
  getClassOfLabelAt: (index: number) => string;
  isVerticalDisplay: () => boolean;
  isHorizontalDisplay: () => boolean;
  isButtonType: () => boolean;
  spacing: () => string;
  getNumberOfRadios: () => number;
}
